/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class PitrIntervalConfig {
  'intervalMinutes': PitrIntervalConfigIntervalMinutesEnum;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "intervalMinutes",
      "baseName": "intervalMinutes",
      "type": "PitrIntervalConfigIntervalMinutesEnum",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return PitrIntervalConfig.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum PitrIntervalConfigIntervalMinutesEnum {
  NUMBER_15 = 15,
  NUMBER_30 = 30,
  NUMBER_60 = 60
}

